function Logo() {
  return (
    <svg
      version="1.1"
      width="40.6px"
      height="40.4px"
      viewBox="0 0 170.6 170.4"
      className="logo"
      style={{ fill: "currentColor" }}
    >
      <path
        d="M68.4,0h36.8c5.3,9,10.9,18.2,16.5,27.7h31.3c5.7,9.5,11.3,18.9,17,28.5l-15,27.3c5.2,8.7,10.3,17.3,15.6,26.2 c-6.4,11.5-12.8,22.9-19.5,34.9h-30.1l-14.6,25.8H65l-14.9-24.8H19.6c-5.7-9.6-11.3-19-17-28.8c4.8-8.6,9.5-17.2,14.6-26.3 C11.6,81,5.9,71.3,0,61.1l18.2-32.3h33.9L68.4,0z M105.3,112.8l13.7,23.1c5.7-10,10.9-19.1,16.4-28.7l16,25.9l13.1-23.3L148.6,83 l14.9-27l-13.4-22.4L135,59.7c-5.3-8.6-10.3-16.8-15.8-25.7c-4.6,8.2-8.8,15.6-13.2,23.3l15.4,26.2L105.3,112.8z M23.2,140.1h30.3 c5,8.3,9.8,16.4,14.4,24.3h26.9L80,139h33.7L100,116.2H66.4L51.2,90.8H24.5l15,26.3H9.7L23.2,140.1z M67.4,54.3h34L113,33.4H79.3 c5.2-9.6,10-18.4,15-27.5H71.5l-16,28.4H22L10.5,55h33.1L27.4,84.2h23.2C56.1,74.4,61.5,64.7,67.4,54.3z M114.8,83.8L101.3,61 H74.2l13.4,22.8H114.8z M82.9,87.2C78.4,79.5,74,72,69.1,63.6l-13,23.3c4.5,7.7,9,15.2,13.9,23.5L82.9,87.2z M76.8,110.1H100 c3.7-6.7,7.3-13.2,11.3-20.3H88.1C84.6,96.2,80.9,102.7,76.8,110.1z M20.6,84.7l13-23.4H7L20.6,84.7z M115.6,27.7L102,4.8 L89.2,27.7L115.6,27.7z M135.4,118.1c-4.1,7.3-7.5,13.6-11.4,20.7h24L135.4,118.1z M90.7,145.6l12,19.7l10.7-19.7H90.7z M143,33.8 h-17.8l9,15.2L143,33.8z M20.5,96.2c-2.9,5.3-5.2,9.4-7.8,14.3h16.1L20.5,96.2z"
      ></path>
    </svg>
  );
}

export default Logo;
